import { TargetSettingsAspectRatioEnum } from 'constants/ratioFormats';

export enum RatioFormatType {
  Youtube = 'youtube',
  FacebookSquare = 'facebookSquare',
  FacebookPortrait = 'facebookPortrait',
  FacebookStory = 'facebookStory',
  InstagramSquare = 'instagramSquare',
  InstagramPortrait = 'instagramPortrait',
  InstagramStory = 'instagramStory',
  Snapchat = 'snapchat',
  Tiktok = 'tiktok',
  Twitter = 'twitter'
}

export type RatioFormatObject = {
  ratioFormatType: RatioFormatType;
  ratio: number;
  ratioText?: TargetSettingsAspectRatioEnum;
  icon: string;
  sizeText: string;
  titleText: string;
};
